import { useEffect } from "react";

import { useState } from "react";

const useIsTouchDevice = () => {
  const [isTouch, setIsTouch] = useState(true);

  useEffect(() => {
    const isTouchDevice = () => {
      return (
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0 ||
        // @ts-expect-error -- msMaxTouchPoints is an IE/legacy-Edge-only property
        navigator.msMaxTouchPoints > 0
      );
    };
    setIsTouch(isTouchDevice());
  }, []);

  return isTouch;
};

export default useIsTouchDevice;
